// ============================================================
// useDashboardStats Hook
// ============================================================

import useDashboardStore from '@/store/dashboardStore';

export function useDashboardStats() {
  const stats = useDashboardStore((s) => s.stats);
  const activities = useDashboardStore((s) => s.activities);
  return { stats, activities };
}
